import { ActionReducerMap } from '@ngrx/store';
import { ConfigState } from './config.state';
import { config } from './config.reducer';

/**
 * Config store.
 *
 * https://github.com/ngrx/platform/blob/master/docs/router-store/api.md#navigation-actions
 */
export const reducers: ActionReducerMap<ConfigState> = {
    config
};



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/modules/config/config.store.ts